import { createContext } from "react";
const GuestMasterContext = createContext({});

export default GuestMasterContext;
